<template>
    <div class="transactionCont">
        <div class="transactionDate">{{ trDate }}</div>
        <div class="transactionEntry" @click="viewStock">
            <font-awesome-icon :icon="icon" class="fa-fw transIcon" color="#333"></font-awesome-icon>
            <div class="transInfo">
                <div class="symbol">{{ entry.stockSymbol }}</div>
            </div>
            <div class="transac">
                <div class="amount">{{ info }}</div>
                <div class="price">{{ total }}</div>
            </div>
            <TransactionEntrySummary :entry="entry"></TransactionEntrySummary>
        </div>
    </div>
</template>

<script>
import DateHelper from '../../infra/DateHelper';
import ListRegularIconMixin from '../help/icons/ListRegularIconMixin';
import StockHtmlHelper from '../stocks/StockHtmlHelper';
import TransactionEntrySummary from './TransactionEntrySummary.vue';

export default {
    mixins: [ListRegularIconMixin],
    components: { TransactionEntrySummary },
    props: {
        entry: Object,
        prev: Object
    },
    created() {
        this.stockHTMLHelper = new StockHtmlHelper()
    },
    computed: {
        icon() {
            const type = this.entry.transactionType || 'buy';
            return this.icons[type];
        },
        info() {
            //const s = this.entry.transactionType === 0 ? '+' : '-';
            const x = this.stockHTMLHelper.formatLocalNumber(this.entry.averageShareCost, this.$i18n.locale)
            return `${this.entry.shareCount} @ ${x}`;
        },
        total() {
            return this.stockHTMLHelper.formatLocalNumber(this.entry.totalTransactionCost, this.$i18n.locale)
        },
        trDate() {
            if (this.prev && this.prev.date === this.entry.date) return '';
            return DateHelper.toSimpleDate(this.entry.date);
        }
    },
    methods: {
        viewStock() {
            this.$router.push({ name: 'Stock', params: { id: this.entry.stockId } });
        }
    }
}
</script>

<style lang="scss" scoped>
.transactionCont {
    display: flex;
    flex-direction: column;
    gap: 5px;
    background-color: #FFF;
    z-index: 10;
    .transactionDate {
        font-size: 0.8em;
        padding: 5px;
        background-color: var(--lightBG);
        text-align: center;
        &:empty {
            display: none;
        }
    }
    .transactionEntry {
        display: flex;
        flex-direction: column;
        gap: 5px;
        border: solid 1px var(--darkBG);
        padding: 10px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        &:hover {
            background-color: var(--agoraBG);
        }
        .transIcon {
            font-size: 1.5em;
            position: absolute;
            top: 5px;
            right: 5px;
            rotate: -15deg;
            opacity: 0.2;
        }
        .transInfo {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .symbol {
                font-weight: bold;
            }
            .date {
                font-size: 0.8em;
                color: #666;
            }
        }
        .transac {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.75em;
            .amount {
            }
            .price {
                font-weight: bold;
            }
        }
    }
}
</style>